@if (!isDismissed && isShaking && !isVisible) {
  <div class="chat-particles" aria-hidden="true">
    @for (p of particles; track p) {
      <span class="chat-particle" [style.--angle]="p * 45 + 'deg'" [style.animation-delay]="p * 0.04 + 's'"></span>
    }
  </div>
}

@if (!isDismissed) {
  <div class="live-chat" [class.live-chat-open]="isVisible" [class.live-chat-shake]="isShaking">
    @if (isVisible) {
      <header class="live-chat-header">
        <img src="images/qchat.png" alt="" class="chat-launcher-image" width="44" height="32">

        <div class="chat-header-meta">
          <div>
            <h4>สอบถามข้อมูล</h4>
          </div>
        </div>

        <div class="chat-header-actions">
          <button
            type="button"
            class="chat-toggle"
            (click)="minimizeChat($event)"
            aria-label="ย่อหน้าต่างแชท">
            <svg class="chat-action-icon" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M5 12h14"/>
            </svg>
          </button>
          <button
            type="button"
            class="chat-close"
            (click)="closeChat($event)"
            aria-label="ปิดแชท">
            <svg class="chat-action-icon" viewBox="0 0 24 24" aria-hidden="true">
              <path d="m6 6 12 12M18 6 6 18"/>
            </svg>
          </button>
        </div>
      </header>
    } @else {
      <button
        type="button"
        class="live-chat-launcher"
        (click)="toggleChat($event)"
        aria-controls="floating-chat-panel"
        aria-expanded="false"
        aria-label="เปิดแชทสอบถามข้อมูล"
        title="สอบถามข้อมูล">
        <img src="images/qchat.png" alt="" class="chat-launcher-image" width="44" height="32">
      </button>
    }

    <div
      id="floating-chat-panel"
      class="chat-panel"
      [class.chat-panel-open]="isVisible"
      [class.chat-panel-animate-in]="isVisible"
      [attr.aria-hidden]="!isVisible">
      @if (requiresIdentity) {
        <div class="chat-home">
          <div class="chat-home-intro">
            <strong>เริ่มต้นสนทนา</strong>
            <p>ใส่ชื่อก่อน แล้วพิมพ์คำถามเกี่ยวกับรหัสรับรองหรือข้อมูลมาตรฐานได้ทันที</p>
          </div>

          <label class="chat-field">
            <span>ชื่อ:</span>
            <input type="text" [(ngModel)]="name" placeholder="กรอกชื่อ">
          </label>

          <label class="chat-field">
            <span>เบอร์โทร:</span>
            <input type="text" [(ngModel)]="tel" placeholder="กรอกเบอร์โทร">
          </label>

          <button type="button" class="chat-button" (click)="confirmIdentity()" [disabled]="!hasIdentity">ตกลง</button>
        </div>
      } @else {
        <div class="chat-list">
          <div class="chat-history" #historyBox>
            @if (messages.length === 0) {
              <div class="chat-state">
                เริ่มพิมพ์คำถามได้เลย ระบบจะช่วยตรวจสอบข้อมูลที่เกี่ยวข้องให้
              </div>
            } @else {
              @for (message of messages; track trackMessage($index, message)) {
                <div class="chat-message" [class.chat-message-self]="isVisitorMessage(message)">
                  @if (!isVisitorMessage(message)) {
                    <img [src]="avatar(message)" alt="" width="32" height="32">
                  }
                  <div class="chat-message-content">
                    <div class="chat-message-meta">
                      <h5>{{ displayName(message) }}</h5>
                      <span class="chat-time">{{ formatTime(message.time) }}</span>
                    </div>
                    <div class="chat-bubble">
                      <p>{{ message.message }}</p>
                    </div>
                  </div>
                  @if (isVisitorMessage(message)) {
                    <img [src]="avatar(message)" alt="" width="32" height="32">
                  }
                </div>
              }

              @if (isSending) {
                <div class="chat-message">
                  <img [src]="systemAvatar" alt="" width="32" height="32">
                  <div class="chat-message-content">
                    <div class="chat-message-meta">
                      <h5>{{ systemName }}</h5>
                      <span class="chat-status">กำลังพิมพ์...</span>
                    </div>
                    <div class="chat-bubble chat-bubble-typing" aria-label="กำลังรอคำตอบ">
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                </div>
              }
            }
          </div>

          <div class="chat-compose">
            <textarea
              #draftInput
              [(ngModel)]="draft"
              (keydown)="onDraftKeydown($event)"
              [disabled]="isSending"
              rows="1"
              placeholder="พิมพ์ข้อความที่นี่..."></textarea>
            <button
              type="button"
              class="chat-button chat-send-button"
              (click)="sendMessage()"
              [disabled]="isSending || !draft.trim()"
              aria-label="ส่งข้อความ">
              <svg aria-hidden="true" viewBox="0 0 24 24" class="chat-send-icon">
                <path d="M3.41 20.59 20.85 12 3.41 3.41 3.4 10.1l12.48 1.9-12.48 1.9.01 6.69Z"/>
              </svg>
            </button>
          </div>
        </div>
      }
    </div>
  </div>
}
